"use client";

import { AuthProvider } from "@/contexts/AuthContext";
import { ToastProvider } from "@/contexts/ToastContext";
import { ImpersonationProvider } from "@/contexts/ImpersonationContext";
import { SidebarVisibilityProvider } from "@/contexts/SidebarVisibilityContext";
import { SidebarSubnavProvider } from "@/contexts/SidebarSubnavContext";
import { ReviewControlsProvider } from "@/contexts/ReviewControlsContext";
import { PostHogProvider } from "@/components/posthog-provider";
import ErrorBoundary from "@/components/ErrorBoundary";
import { SuperAdminIndicator } from "@/components/super-admin-indicator";
import { ImpersonationBanner } from "@/components/impersonation-banner";
import { SpeedInsights } from "@vercel/speed-insights/next";

export function ClientProviders({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <ToastProvider>
        <ImpersonationProvider>
          <SidebarVisibilityProvider>
            <SidebarSubnavProvider>
            <ReviewControlsProvider>
              <PostHogProvider>
                <ErrorBoundary>
                  <ImpersonationBanner />
                  {children}
                  <SpeedInsights />
                </ErrorBoundary>
                <SuperAdminIndicator />
              </PostHogProvider>
            </ReviewControlsProvider>
            </SidebarSubnavProvider>
          </SidebarVisibilityProvider>
        </ImpersonationProvider>
      </ToastProvider>
    </AuthProvider>
  );
}
